import Phaser from 'phaser';
import { GAME_CONFIG } from './config/GameConfig';

// Inicializar el juego
new Phaser.Game(GAME_CONFIG);
